import React, {useEffect, useState} from 'react'
import MDBox from "../../../../components/MDBox";
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import LocalStorage from "../../../../utils/LocalStorage";
import {getMultiAddressList, Logout, onErrorAlert, onSuccessAlert, removeMultiAddress} from "../../../../actions";
import {noop} from "lodash";
import {enUS, zhCN} from '@mui/x-data-grid/locales';
import {MuiDataGrid} from "../../../../components/MuiDatagrid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import EditIcon from '@mui/icons-material/Edit';
import MDButton from "../../../../components/MDButton";
import AddIcon from '@mui/icons-material/Add';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import PaperComponent from "../../../../components/MuiDraggableDialog";
import OwnerDiscountAdd from "./OwnerDiscountAdd";
import { v4 as uuidv4 } from 'uuid';
import {checkPermission, PERMISSION_DICT} from "../../../../utils/Users_Roles_Permission";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import {LoadingButton} from "@mui/lab";
import CircularProgress from "@mui/material/CircularProgress";
import {Alert, FormControl, FormHelperText} from "@mui/material";
import {downloadInboundTemplate, inboundsFilter} from "../../../../actions/inbounds/inboundsAction";
import MDTypography from "../../../../components/MDTypography";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../../../components/MDInput";
import {MyFileUploader} from "../../../../components/FileUploaders/Uploader";
import {ASN_Import, Discount_Import_Discounts} from "../../../../config";
import {cargoOwnerDiscountList, downloadCargoDiscountTemplate} from "../../../../actions/customer/customerAction";
import {useDebounce} from "use-debounce";
import {cargoOwnerInfo, ownerFilter, ownerSelected} from "../../../../actions/inventory/inventoryAction";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";

const OwnerDiscountList = ({info, setTotal,total,setList,list }) => {

    const {t, i18n} = useTranslation();
    const [condition, setCondition] = useState('')
    const [isActive, setIsActive] = useState(null)
    const [feeType, setFeeType] = useState(null)
    const [loading, setLoading] = useState(false)
    const [height, setHeight] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [pageNum, setPageNum] = useState(1)
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 5,
    });
    const nav = useNavigate()
    const dispatch = useDispatch()
    const languageSelect = useSelector(state => state?.common?.language)
    const fixedNavbar = useSelector(state => state?.common?.fixedNavbar)
    const ownerInfo = useSelector(state => state?.inventory?.ownerInfo)
    const feeNoList = useSelector(state => state?.billing?.feeList)
    const [discountDetail,setDiscountDetail] = useState(null)
    const [isOpen,setIsOpen] = useState(false)
    const [mode,setMode] = useState('Add')//for address
    const [uploadLoading,setUploadLoading] = useState(false)
    const [isImportOpen,setIsImportOpen] = useState(false)
    const [ownerList ,setOwnerList] =useState([])
    const [ownerId, setOwnerId] = useState(null)
    const [owner,setOwner] = useState([])
    const [inputOwnerValue,setInputOwnerValue] = useState()
    const [ownerValue] = useDebounce(inputOwnerValue, 100);
    // const [list,setList] = useState([])
    // const [total,setTotal] = useState(0)
    const activeArr = [
        {
            id: 1,
            value: 'Y',
            label: `${t(`ProductPage.OPEN`)}`
        },
        {
            id: 2,
            value: 'N',
            label: `${t(`ProductPage.CLOSED`)}`
        },
        {
            id: 3,
            value: 'C',
            label: `${t(`ProductPage.CREATED`)}`
        },

    ]



    const columns = [
        {
            field: 'feeDescr1',
            headerName: t('DiscountManagementPage.Discount Name'),
            width: 200,
            renderCell: (params) => (
                <Grid sx={{display:"flex",justifyContent: "space-between",alignItems: "center"}}
                      onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid >
                            {params?.value}
                        </Grid>
                    </Tooltip >
                </Grid>
            )
        },
        {
            field: 'feeType',
            headerName: t('DiscountManagementPage.Fee No.'),
            width: 100,
            renderCell: (params) => (
                <Grid sx={{display:"flex",justifyContent: "space-between",alignItems: "center"}}
                      onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid >
                            {params?.value}
                        </Grid>
                    </Tooltip >
                </Grid>
            )
        },
        {
            field: 'discount',
            headerName: t('DiscountManagementPage.Discount'),
            width: 100,
            renderCell: (params) => (
                <Grid>
                    <Tooltip title={params?.value}>
                        <Grid >
                            {params?.value}%
                        </Grid>
                    </Tooltip >
                </Grid>
            )
        },
        {
            field: 'warehouseId',
            headerName: t('DiscountManagementPage.Warehouse ID'),
            width: 200,
            renderCell: (params) => (
                <Grid>
                    <Tooltip title={params?.value}>
                        <Grid >
                            {params?.value}
                        </Grid>
                    </Tooltip >
                </Grid>
            )
        },
        {
            field: 'warehouseDescr1',
            headerName: t('Warehouse'),
            width: 200,
            renderCell: (params) => (
                <Grid>
                    <Tooltip title={params?.value}>
                        <Grid >
                            {params?.value}
                        </Grid>
                    </Tooltip >
                </Grid>
            )
        },
        {
            field: 'activeFlag',
            headerName: t('DiscountManagementPage.Active Flag'),
            width: 200,
            renderCell: (params) => (
                <Grid>
                    <Tooltip title={params?.value}>
                        <Grid>
                            <div>
                                {activeArr.find(v => v.value === params.value)?.label}
                            </div>
                        </Grid>
                    </Tooltip>
                </Grid>
            )
        },
        {
            field: 'action',
            headerName: t('Action'),
            width: 60,
            renderCell: (params) => (
                <div>
                    <Tooltip title={t('Edit')}>
                        <IconButton color="primary"
                                    disabled={!checkPermission(PERMISSION_DICT.CustomerCargoDiscountModify)}
                                    onClick={()=>{
                                        setMode('Edit')
                                        setDiscountDetail(params?.row)
                                        setIsOpen(true)
                                    }}
                        >
                            <EditIcon/>
                        </IconButton>
                    </Tooltip>
                </div>
            )
        },

    ]


    const onSearchSuccess = (data) => {
        setList( data?.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }))
        setTotal(data?.total)

    }


    useEffect(()=>{
        if(ownerValue){
            const axiosPost = async () => {
                await dispatch(ownerSelected({condition: ownerValue, userName: LocalStorage.getItem('username')}, (data)=>setOwnerList(data)))
            }
            axiosPost().then()
        } else {
            setOwnerList([])
        }
    },[ownerValue])

    useEffect(() => {
        if(info.ocpOwnerId){
            setInputOwnerValue(info.ocpOwnerId)
        }

    }, [info]);


    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }


    const saveFormData = () => {
        let formData = {}
        formData.ownerId = info.ocpOwnerId
        formData.pageNum = paginationModel.page + 1
        formData.pageSize = paginationModel.pageSize

        formData.activeFlag = isActive?.value
        formData.discountName = condition
        formData.feeType = feeType?.feeNo


        if (LocalStorage.getItem('username')) {
            formData.userName = LocalStorage.getItem('username')
        } else {
            return null
        }

        return formData
    }

    const getDiscountList = () =>{
        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }

        const axiosPost = async () => {

            await dispatch(cargoOwnerDiscountList(formData, onSearchSuccess, onError))
        }
        checkPermission(PERMISSION_DICT.CustomerCargoInfo)&& info.ocpOwnerId && axiosPost().then()
    }

    useEffect(() => {

        getDiscountList()


    }, [paginationModel.pageSize, paginationModel.page,feeType,condition,isActive,languageSelect]);

    function handlePaginationChange(data) {
        setPaginationModel(data)
        // setPageNum(() => data.page + 1)
        // setPageSize(() => data.pageSize)
    }

    const handleCellDoubleClick = (params) => {
        const textToCopy = params?.value;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };
    // const discountList = (list) =>{
    //     return list.map((ele) => {
    //         return {...ele, id: uuidv4()}
    //     })
    // }



    // useEffect(() => {
    //
    //     let formData = {}
    //     if (saveFormData()) {
    //         formData = saveFormData()
    //     } else {
    //         return nav('/')
    //     }
    //
    //     const axiosPost = async () => {
    //
    //         setLoading(true)
    //         await dispatch(getMultiAddressList(formData, onSearchSuccess, onError))
    //     }
    //     axiosPost().then()
    //
    // }, [pageSize, pageNum]);

    useEffect(() => {
        if (fixedNavbar) {
            setHeight(document.getElementById('appBar')?.clientHeight + 10)
        } else {
            setHeight(0)
        }

    }, [fixedNavbar]);


    const onImportSuccees = async (data) => {
        dispatch(onSuccessAlert(data))

        getDiscountList()
    }

    const onUrlSuccess = (msg) => {
        dispatch(onSuccessAlert(`download ${msg} successfully`))

    }

    const handleReset = () => {
        setCondition('')
        setIsActive(null)
        setFeeType(null)
        // setPageNum(1)
        // setPageSize(5)
        setPaginationModel({
            page: 0,
            pageSize: 5,
        });
    }

    return (<React.Fragment>
            <MDBox pb={1}>
                {

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            flexWrap: 'wrap',
                            justifyContent: "flex-end",
                        }}
                    >
                        <Grid padding={0} marginTop={-1} container spacing={1}  >
                            <Grid item xs={12} md={2.4}  >
                                <MDBox>
                                    <FormControl fullWidth >
                                        <MDInput
                                            label= {t('CustomerPage.Search By Discount Name')}
                                            value={condition}
                                            onChange={(e) => setCondition(e.target.value)}
                                            variant={'standard'}
                                        />
                                    </FormControl>
                                </MDBox>
                            </Grid>
                            <Grid item xs={12} md={2.4}>
                                <MDBox>
                                    <FormControl fullWidth >
                                        <Autocomplete
                                            sx={{
                                                '& .MuiAutocomplete-inputRoot': {
                                                    minHeight: '30px',   // 设置最小高度
                                                    padding: '0px 8px',  // 减小内边距
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '4px 0px',  // 减小输入框的内边距
                                                },
                                                '& .MuiFormLabel-root': {
                                                    fontSize: '0.85rem', // 调整标签字体大小
                                                    top: '-5px',         // 调整标签位置
                                                },
                                            }}
                                            required
                                            disablePortal
                                            options={feeNoList}
                                            sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                            getOptionLabel={(option) => { return `${option?.feeNo}: ${option?.description}` }}
                                            isOptionEqualToValue={(option, value) => option?.feeNo === value?.feeNo}
                                            value={feeType}
                                            onChange={(e, v) => setFeeType(v)}
                                            renderInput={(params) =>
                                                <MDInput
                                                    {...params}
                                                    label={t('CustomerPage.Fee Type')}
                                                    variant={'standard'}
                                                />}
                                        />
                                    </FormControl>
                                </MDBox>
                            </Grid>
                            <Grid item xs={12} md={2.4}>
                                <MDBox>
                                    <FormControl fullWidth >
                                        <Autocomplete
                                            sx={{
                                                '& .MuiAutocomplete-inputRoot': {
                                                    minHeight: '30px',   // 设置最小高度
                                                    padding: '0px 8px',  // 减小内边距
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '4px 0px',  // 减小输入框的内边距
                                                },
                                                '& .MuiFormLabel-root': {
                                                    fontSize: '0.85rem', // 调整标签字体大小
                                                    top: '-5px',         // 调整标签位置
                                                },
                                            }}
                                            required
                                            disablePortal
                                            options={activeArr}
                                            sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                            getOptionLabel={(option) => `${option?.label}`}
                                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                            value={isActive}
                                            onChange={(e, v) => setIsActive(v)}
                                            renderInput={(params) =>
                                                <MDInput
                                                    {...params}
                                                    label={t("ProductPage.Active")}
                                                    variant={'standard'}
                                                />}
                                        />
                                    </FormControl>
                                </MDBox>
                            </Grid>
                            <Grid item xs={12} md={1} sx={{display:'flex',justifyContent:'flex-end',alignItems:'center'}}>
                                <MDButton sx={{marginLeft:1,height:"30px"}} size={'small'} color="secondary" variant="outlined" startIcon={<CleaningServicesIcon />} onClick = {handleReset}>
                                    {t('reset')}
                                </MDButton>
                            </Grid>
                            <Grid item xs={12} md={3.8} sx={{display:'flex',justifyContent: 'flex-end',alignItems:'center'}}>
                                <MDButton
                                    disabled={!info?.ocpOwnerId}
                                    sx={{height:"30px"}}
                                    variant="gradient" color="info" size="small"
                                          startIcon={<AddIcon sx={{fontSize: "40px"}}/>}
                                          onClick={() => setIsOpen(true)}
                                >
                                    {t('DiscountManagementPage.Add New Discount')}
                                </MDButton>
                            </Grid>


                        </Grid>
                    </div>
                }

                <Grid >
                    <MuiDataGrid
                        // columnHeaderHeight={40}
                        rowHeight={40}
                        sx={{
                            '& .MuiDataGrid-main': {
                                overflow: "unset"
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                position: "sticky",
                                top: height,
                                zIndex: '1100'
                            },
                        }}
                        localeText={languageSelect === 'zh' ? zhCN.components.MuiDataGrid.defaultProps.localeText : enUS.components.MuiDataGrid.defaultProps.localeText}
                        disableRowSelectionOnClick
                        disableColumnMenu={true}
                        disableColumnFilter={true}
                        disableColumnSorting={true}
                        getRowId={(row) => row?.id}
                        autoHeight
                        rowCount={total}
                        loading={loading}
                        rows={list}
                        columns={columns}
                        pageSizeOptions={[5, 15, 30]}
                        initialState={{
                            pagination: {paginationModel: {page: 0, pageSize: 5}},
                        }}
                        paginationModel={paginationModel}
                        paginationMode={"server"}
                        onPaginationModelChange={
                            handlePaginationChange
                        }

                    />
                </Grid>
            </MDBox>

            <OwnerDiscountAdd
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                setMode={setMode}
                mode={mode}
                pageLoading={loading} setPageLoading={setLoading}
                pageFormData={saveFormData()}
                discountDetail={discountDetail}
                info={info}
                getDiscountList={getDiscountList}
            />

            {/*<Dialog*/}
            {/*    open={isImportOpen}*/}
            {/*    onClose={() => {*/}
            {/*        setOwnerId(null)*/}
            {/*        setIsImportOpen(false)*/}
            {/*    }}*/}
            {/*    aria-labelledby="alert-dialog-title"*/}
            {/*    aria-describedby="alert-dialog-description"*/}
            {/*    fullWidth*/}
            {/*    maxWidth={'md'}*/}
            {/*>*/}
            {/*    <DialogTitle id="alert-dialog-title">*/}
            {/*        <div>Import Cargo Owner Discount List</div>*/}
            {/*    </DialogTitle>*/}
            {/*    <DialogContent>*/}
            {/*        <DialogContentText id="alert-dialog-description"*/}
            {/*                           sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>*/}
            {/*            <Grid>*/}
            {/*                <Alert*/}
            {/*                    severity="warning"*/}
            {/*                    action={*/}
            {/*                        <Button*/}
            {/*                            disabled={!( checkPermission(PERMISSION_DICT.CustomerCargoDiscountAdd))}*/}
            {/*                            onClick={() => dispatch(downloadCargoDiscountTemplate(onUrlSuccess,onError))}>download</Button>*/}
            {/*                    }*/}
            {/*                    variant="outlined"*/}
            {/*                >*/}
            {/*                    <MDTypography display="block" variant="h6" color={'text'}>*/}
            {/*                        Download the Excel Template Here*/}
            {/*                    </MDTypography>*/}
            {/*                </Alert>*/}
            {/*            </Grid>*/}
            {/*            {*/}
            {/*                checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&*/}
            {/*                <Grid width='50%' justifyContent='space-between' alignItems='center' spacing={2} mt={5}>*/}
            {/*                    <FormControl fullWidth>*/}
            {/*                        <Autocomplete*/}
            {/*                            required*/}
            {/*                            disablePortal*/}
            {/*                            options={ownerList}*/}
            {/*                            disableClearable={true}*/}
            {/*                            // readOnly={type === 'Preview'}*/}
            {/*                            getOptionLabel={(option) => `ID: ${option?.ownerId} Name: ${option?.ownerName}`}*/}
            {/*                            isOptionEqualToValue={(option, value) => option?.ownerId === value?.ownerId}*/}
            {/*                            value={ownerId}*/}
            {/*                            onChange={(e, v) => setOwnerId(v)}*/}
            {/*                            renderInput={(params) =>*/}
            {/*                                <MDInput*/}
            {/*                                    {...params}*/}
            {/*                                    label={"Owner"}*/}
            {/*                                    required*/}
            {/*                                    InputLabelProps={{ shrink: true }}*/}
            {/*                                />}*/}
            {/*                        />*/}
            {/*                        <FormHelperText*/}
            {/*                            sx={{ fontWeight: 'medium' }}></FormHelperText>*/}
            {/*                    </FormControl>*/}
            {/*                </Grid>*/}
            {/*            }*/}
            {/*            <Grid>*/}
            {/*                <MyFileUploader*/}
            {/*                    list={[]}*/}
            {/*                    fileType='xlsx'*/}
            {/*                    onSuccess={onImportSuccees}*/}
            {/*                    onError={onError}*/}
            {/*                    maxKB={5 * 1024}*/}
            {/*                    acceptDefaultTypes={false}*/}
            {/*                    baseFileURL={Discount_Import_Discounts}*/}
            {/*                    owner={ownerId}*/}
            {/*                    uploadDisabled={!checkPermission(PERMISSION_DICT.CustomerCargoDiscountAdd)}*/}
            {/*                />*/}
            {/*            </Grid>*/}
            {/*        </DialogContentText>*/}
            {/*    </DialogContent>*/}
            {/*    <DialogActions>*/}
            {/*        <MDButton color={'primary'} onClick={() => {*/}
            {/*            setOwnerId(null)*/}
            {/*            setIsImportOpen(false)*/}
            {/*        }}>Cancel</MDButton>*/}
            {/*    </DialogActions>*/}
            {/*</Dialog>*/}

            {/*<Dialog*/}
            {/*    open={isAlertOpen}*/}
            {/*    onClose={() => {*/}
            {/*        setIsAlertOpen(false)*/}
            {/*    }}*/}
            {/*    PaperComponent={PaperComponent}*/}
            {/*    aria-labelledby="draggable-dialog-title"*/}
            {/*    aria-describedby="alert-dialog-description"*/}
            {/*    fullWidth*/}
            {/*    maxWidth={'sm'}*/}
            {/*>*/}
            {/*    <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>*/}
            {/*        <div>{t("Are you sure?")}</div>*/}
            {/*    </DialogTitle>*/}
            {/*    <DialogContent>*/}
            {/*        <DialogContentText id="alert-dialog-description">*/}
            {/*            {`Do you really want to delete The Address:`}*/}
            {/*            <span style={{*/}
            {/*                color: 'red',*/}
            {/*                padding: '10px',*/}
            {/*                fontWeight: 'bold'*/}
            {/*            }}>{selectDeleteRow?.address1}</span>*/}
            {/*            ? {t('This process cannot be undone')}*/}
            {/*        </DialogContentText>*/}
            {/*    </DialogContent>*/}
            {/*    <DialogActions>*/}
            {/*        <MDButton onClick={() => setIsAlertOpen(false)}>Disagree</MDButton>*/}
            {/*        <MDButton onClick={()=>{onSubmit(selectDeleteRow)}} autoFocus sx={{ color: 'red' }} variant='outlined'>*/}
            {/*            Agree*/}
            {/*        </MDButton>*/}
            {/*    </DialogActions>*/}
            {/*</Dialog>*/}
        </React.Fragment>
    )
}

export default OwnerDiscountList